<div #snap="itemSnappedHeight"
     class="insured-list-container"
     [albertItemSnappedHeight]="itemSize"
>
  @let items = (insuredItems$ | async);
  @let isLoading = (loading$ | async);

  @if (items && items.length > 0) {
    <p-virtualscroller
      [itemSize]="itemSize"
      [scrollHeight]="snap.scrollHeight()"
      [items]="items"
      [lazy]="true"
      [loading]="(loading$ | async) ?? false"
      [showLoader]="true"
      [step]="pageSize"
      (onLazyLoad)="onLazyLoad($event)"
    >
      <ng-template #item
                   let-item
      >
        <div class="box-border h-[58px] w-[220px] overflow-hidden border-b border-gray-300"
             [attr.data-test]="'insured-item-' + item.uuid"
        >
          @if (item) {
            <albert-list-view-insured-list-item
              [item]="item"
              [selected]="item.uuid === selectedUuid()"
              (itemClicked)="onEntrySelected()"
            />
          } @else {
            <p-skeleton class="p-2"
                        height="2.5rem"
                        width="100%"
            />
          }
        </div>
      </ng-template>
    </p-virtualscroller>
  } @else if (isLoading) {
    <div class="p-2">
      @for (_ of [0, 1, 2, 3, 4, 5]; track _) {
        <p-skeleton class="mb-2"
                    height="2.5rem"
                    width="100%"
        />
      }
    </div>
  }
</div>
